import { LayoutSetup, StepItemsList } from "@/components/setup/layout-setup";
import { useAdminMode } from "@/contexts/admin-mode-provider";
import { useTeams } from "@/contexts/teams-provider";
import { useTranslation } from "@/hooks/useTranslation";
import { redirectTo } from "@/lib/location";
import { useMemo } from "react";
import { SetupResubscriptionIntroductionPage } from "./resubscription/0-introduction";
import { SetupResubscriptionPaymentMethodPage } from "./resubscription/1-payment-method";
import { SetupResubscriptionFinishPage } from "./resubscription/2-finish";

export const SetupResubscriptionPage = () => {
  const { teamSelected, isUser } = useTeams();
  const { isAdminMode } = useAdminMode();
  const { t } = useTranslation();

  const isBillingEnabled = teamSelected?.billingEnabled !== false;

  const steps: StepItemsList = useMemo(() => {
    const baseSteps: StepItemsList = [
      {
        id: "introduction",
        label: t("setup.resubscription.steps.introduction"),
        element: <SetupResubscriptionIntroductionPage />,
      },
    ];

    if (isBillingEnabled) {
      baseSteps.push({
        id: "payment-method",
        label: t("setup.resubscription.steps.paymentMethod"),
        element: <SetupResubscriptionPaymentMethodPage />,
      });
    }

    baseSteps.push({
      id: "finish",
      label: t("setup.resubscription.steps.finish"),
      element: <SetupResubscriptionFinishPage />,
    });

    return baseSteps;
  }, [t, isBillingEnabled]);

  if (
    !(
      (teamSelected?.billingError === "subscription_deleted" ||
        teamSelected?.billingError === "no_active_subscription") &&
      !isUser &&
      !isAdminMode
    )
  ) {
    redirectTo("/");
    return null;
  }

  return <LayoutSetup steps={steps} />;
};
